import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GeneralService } from '../../services/general.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TabRouter } from '../../models/components-general/router.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tab-menu-simple',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, CommonModule, TranslateModule],
  templateUrl: './tab-menu-simple.html',
})
export class TabMenuSimple {
  public showLeftButton = false;
  public showRightButton = false;
  @Output() public changeSelected = new EventEmitter<TabRouter>();
  @Input() tabs: TabRouter[] = [];
  @Input() upgradeSelected = true;
  @Input() indexSelected = 0;
  @Input() titule = 'Titulo';
  @Input() paramsName = 'paramTab';

  @ViewChild('tabsContainer', { static: false }) tabsContainer?: ElementRef<HTMLDivElement>;
  @HostListener('window:resize')
  onResize() {
    this.updateScrollButtons();
  }
  constructor(
    private route: ActivatedRoute,
    private generalService: GeneralService,
  ) {}

  public ngOnInit(): void {
    if (this.upgradeSelected) {
      this.subscribeToParam();
    }
  }

  private subscribeToParam(): void {
    this.route.queryParams.subscribe((params: Params) => {
      if (params['indexSelected']) {
        const value = Number(params['indexSelected']);
        if (!isNaN(value)) {
          this.indexSelected = value;
        }
      }
    });
  }

  // Emite el índice seleccionado al componente padre
  public onTabChange(tab: TabRouter): void {
    this.changeSelected.emit(tab);
  }

  // Detectar scroll manual para actualizar visibilidad de botones
  public onTabsScroll(): void {
    this.updateScrollButtons();
  }

  ngAfterViewInit(): void {
    this.updateScrollButtons();
    setTimeout(() => this.updateScrollButtons(), 100); // Por si el render es tardado
  }

  private updateScrollButtons(): void {
    const container = this.tabsContainer?.nativeElement;
    if (!container) return;
    this.showLeftButton = container.scrollLeft > 0;
    this.showRightButton = container.scrollWidth > container.clientWidth + container.scrollLeft + 1;
  }

  // Mueve el scroll del contenedor de tabs a la izquierda o derecha
  public scrollTabs(direction: 'left' | 'right'): void {
    const container = this.tabsContainer?.nativeElement;
    if (!container) return;
    const scrollAmount = 100;
    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }
    setTimeout(() => this.updateScrollButtons(), 100);
  }
}
